import { render } from "./AiV2Page.vue?vue&type=template&id=47afa530"
import script from "./AiV2Page.vue?vue&type=script&lang=js"
export * from "./AiV2Page.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__